<template>
  <div class="ShujiHokoku">
    <el-card id="shujiCard">
      <el-form ref="form" :model="form" :rules="rules" label-width="115px" v-loading="loading" size="medium">
        <el-row>
          <el-col :span="12">
            <el-form-item label="スタッフ名" prop="shainShimei">
              <span id="shainShimei">{{form.shainShimei}}</span>
              <span id="copyButton"><el-button type="info" v-if="form.shuhoJokyoKubun < '21'" @click="onCopyLastWeek()" size="mini">前週コピー</el-button></span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状況" prop="shuhoJokyoKubun" label-width="95px">
              <span id="shainShimei">{{getJokyo}}</span>
              <el-tooltip v-if="form.jochoComment" effect="light" placement="bottom-end">
                <div slot="content" class="jochoComment-tooltip">{{form.jochoComment}}</div>
                <el-link type="success">上長コメント</el-link>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="週開始日" prop="torokuBi">
              <el-button type="default" @click="onChange(-7)" size="medium" icon="el-icon-arrow-left">前週</el-button>
              <el-date-picker v-model="form.torokuBi" @change="onChange" id="torokuBi" value-format="yyyy-MM-dd" :editable="false" :clearable="false" :picker-options="pickerOptions" size="medium"></el-date-picker>
              <el-button type="default" @click="onChange(7)" size="medium">翌週 <i class="el-icon-arrow-right" /></el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部署名" prop="bushoMei" id="bushoMei" label-width="95px">
              <el-input v-model="form.bushoMei" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="取引先名" prop="torihikisakiMei" id="torihikisakiMei">
              <el-input v-model="form.torihikisakiMei" :maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="現場名" prop="genbaMei" id="genbaMei" label-width="95px">
              <el-input v-model="form.genbaMei" :maxlength="100"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="期間" prop="kikan" id="kikan">
              <span id="kikanLabel">{{form.kikan}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="残業時間" prop="zangyo" id="zangyo" label-width="95px">
              <span id="zangyoLabel">{{form.zangyoJikan}}</span><span id="minyuryokuAlert" v-if="form.minyuryokubiFlag">※勤務実績未入力日があります。</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="subtitleBar">
          <el-tag effect="dark">個人の状況（報告・連絡・相談）</el-tag>
        </el-form-item>
        <el-form-item label="体調" prop="taicho">
          <el-slider v-model="form.taicho" :step="1" :min="0" :max="10" :marks="marksTaicho" show-stops></el-slider>
        </el-form-item>
        <el-form-item label="負荷" prop="fuka">
          <el-slider v-model="form.fuka" :step="1" :min="0" :max="10" :marks="marksFuka" show-stops></el-slider>
        </el-form-item>
        <el-form-item label="現場満足度" prop="genbaManzokudo">
          <el-slider v-model="form.genbaManzokudo" :step="1" :min="0" :max="10" :marks="marksGenbaManzokudo" show-stops></el-slider>
        </el-form-item>
        <el-form-item><!-- 改行用 --></el-form-item>
        <el-form-item class="subtitleBar">
          <el-tag effect="dark">スケジュール</el-tag>
        </el-form-item>
        <el-form-item label="今週タスク" prop="thisWeekTask">
          <el-input v-model="form.thisWeekTask" :autosize="{ minRows: 5}" :maxlength="1000" resize="vertical" type="textarea" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="来週予定タスク" prop="nextWeekTask">
          <el-input v-model="form.nextWeekTask" :autosize="{ minRows: 5}" :maxlength="1000" resize="vertical" type="textarea" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="課題・困りごと" prop="problems">
          <el-input v-model="form.problems" :autosize="{ minRows: 5}" :maxlength="1000" resize="vertical" type="textarea" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="変則勤務・勤怠変更等" prop="irregularWork" id="irregularWork" label-width="85px">
          <el-input v-model="form.irregularWork" :autosize="{ minRows: 5}" :maxlength="1000" resize="vertical" type="textarea" show-word-limit></el-input>
        </el-form-item>
        <el-form-item class="subtitleBar">
          <el-tag effect="dark">現場・その他の状況（報告・連絡・相談）</el-tag>
        </el-form-item>
        <el-form-item label="その他連絡" prop="sonotaJokyo">
          <el-input v-model="form.sonotaJokyo" :autosize="{ minRows: 5}" :maxlength="1000" resize="vertical" type="textarea" show-word-limit></el-input>
        </el-form-item>
        <div class="bottom-items">
          <el-button type="primary" v-if="form.shuhoJokyoKubun <= '11'" @click="onSave('form', '11')">下書き保存</el-button>
          <el-button type="success" v-if="form.shuhoJokyoKubun <= '11'" @click="onSave('form', '21')">提出</el-button>
          <el-button type="primary" v-if="form.shuhoJokyoKubun > '11'" @click="onSave('form', form.shuhoJokyoKubun)">保存</el-button>
          <el-button type="default" :disabled="form.shuhoJokyoKubun < '11'" @click="onDownload">Excel出力</el-button>
          <el-button type="default" v-if="form.shuhoJokyoKubun <= '11'" :disabled="form.shuhoJokyoKubun < '11'" @click="onDelete">削除</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { notifySuccess, notifyWarning, notifyError, downloadFile } from '../utils.js'

export default {
  name: 'ShujiHokoku',
  data() {
    return {
      form: {
        shainId: '',
        shainShimei: '',
        torokuBi: '',
        bushoMei:'',
        torihikisakiMei: '',
        genbaMei: '',
        kikan:'',
        taicho: 5,
        fuka: 5,
        genbaManzokudo: 5,
        thisWeekTask: '',
        nextWeekTask: '',
        problems: '',
        irregularWork: '',
        sonotaJokyo: '',
        shuhoJokyoKubun: '',
        zangyoJikan: '',
        minyuryokubiFlag: false,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getDay() != 1;
        }
      },
      marksTaicho: {
        0: '悪い',
        5: '普通',
        10: '良い',
      },
      marksFuka: {
        0: '低い',
        5: '普通',
        10: '高い',
      },
      marksGenbaManzokudo: {
        0: '低い',
        5: '普通',
        10: '高い',
      },
      rules: {
      },
      loading: true,
      checkList: [],
    }
  },
  computed: {
    getJokyo() {
      switch(this.form.shuhoJokyoKubun) {
        case '11':
          return '下書き';
        case '21':
          return '提出済';
        case '31':
          return '上長確認済';
        default:
          return '';
      }
    },
  },
  created() {
    if (this.$route.params.torokuBi === undefined) {
      this.form.torokuBi = this.$parent.getTorokuBi();
    } else {
      this.form.torokuBi = this.$route.params.torokuBi;
    }
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$parent.setTorokuBi(this.form.torokuBi);
      let url = '/gwr/shuho/shujiHokoku/' + this.form.torokuBi;
      this.$axios.get(url)
          .then((response) => {
            this.form.shainId = response.data.shainId;
            this.form.shainShimei = response.data.shainShimei;
            this.form.bushoMei = response.data.bushoMei;
            this.form.torihikisakiMei = response.data.torihikisakiMei;
            this.form.genbaMei = response.data.genbaMei;
            this.form.kikan = response.data.kikan;
            this.form.zangyoJikan = response.data.zangyoJikan;
            this.form.taicho = response.data.taicho;
            this.form.fuka = response.data.fuka;
            this.form.genbaManzokudo = response.data.genbaManzokudo;
            this.form.thisWeekTask = response.data.thisWeekTask;
            this.form.nextWeekTask = response.data.nextWeekTask;
            this.form.problems = response.data.problems;
            this.form.irregularWork = response.data.irregularWork;
            this.form.sonotaJokyo = response.data.sonotaJokyo;
            this.form.shuhoJokyoKubun = response.data.shuhoJokyoKubun;
            this.form.minyuryokubiFlag = response.data.minyuryokubiFlag;
            this.form.jochoComment = response.data.jochoComment == 'null' ? '' : response.data.jochoComment;            
            this.loading = false;
          })
          .catch((error) => {
            notifyError(this, error, 'データ取得エラー');
          });
    },
    onChange(offset) {
      this.loading = true;
      this.$refs["form"]?.validate();
      if (!this.form.torokuBi) {
        // 表示日がブランクの場合、後続処理は実行しない。
        this.loading = false;
        return;
      }
      if (offset !== undefined) {
        this.form.torokuBi = this.$moment(this.form.torokuBi).add(offset, 'days').format('YYYY-MM-DD');
      }
      this.getData();
    },
    onCopyLastWeek() {
      let message = '前週の入力内容をコピーして、下書き保存します。<br/>（既に入力されている内容は上書きされます。）<br/>よろしいですか？';
      this.$confirm(message, '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'info',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.loading = true;
        this.$axios.get('/gwr/shuho/copyLastWeekShuho/' + this.form.torokuBi + '/' + this.form.shainId)
          .then((response) => {
            this.form.shainId = response.data.shainId;
            this.form.shainShimei = response.data.shainShimei;
            this.form.bushoMei = response.data.bushoMei;
            this.form.torihikisakiMei = response.data.torihikisakiMei;
            this.form.genbaMei = response.data.genbaMei;
            this.form.kikan = response.data.kikan;
            this.form.zangyoJikan = response.data.zangyoJikan;
            this.form.taicho = response.data.taicho;
            this.form.fuka = response.data.fuka;
            this.form.genbaManzokudo = response.data.genbaManzokudo;
            this.form.thisWeekTask = response.data.thisWeekTask;
            this.form.nextWeekTask = response.data.nextWeekTask;
            this.form.problems = response.data.problems;
            this.form.irregularWork = response.data.irregularWork;
            this.form.sonotaJokyo = response.data.sonotaJokyo;
            this.form.shuhoJokyoKubun = response.data.shuhoJokyoKubun;
            this.form.minyuryokubiFlag = response.data.minyuryokubiFlag;
            this.form.jochoComment = response.data.jochoComment;            
            this.loading = false;
          })
          .catch((error) => {
            notifyError(this, error, 'データ取得エラー');
          });
        });
    },
    onSave(formName, shuhoJokyoKubun) {
      let message = '';
      let sendMail = false;
      let shori = '保存';
      if (shuhoJokyoKubun == '11') {
        message = '下書き中は、他の社員は参照できません。<br/>下書き保存しますか？';
      } else if (this.form.shuhoJokyoKubun == '11') {
        if (this.form.minyuryokubiFlag) {
          message = "<span style='color: red'>※勤務実績未入力の日があるので、<br/>残業時間が正しく計算できていません。</span><br/><br/>";
        }
        message += '提出すると、上長、労務等の社員が、<br/>週報を参照できるようになります。<br/>提出しますか？';
        sendMail = true;
        shori = '提出';        
      } else {
        message = '入力内容を保存します。よろしいですか？';
      }
      this.$confirm(message, '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'info',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            let params = this.createParams(shuhoJokyoKubun, sendMail);
            this.$axios.post('/gwr/shuho/shujiHokoku', params)
                .then((response) => {
                  this.getData();
                  this.loading = false;
                  if (response.status == '200') {
                    notifySuccess(this, '完了', '週報を' + shori + 'しました。');
                  } else {
                    notifyWarning(this, '完了', shori + 'が完了しましたがメール送信に失敗しました。別途連絡をお願いします。');
                  }
                  this.getData();
                })
                .catch((error) => {
                  notifyError(this, error, '保存エラー');
                });
          } else {
            this.$notify({
              title: '入力エラー',
              message: '入力欄に表示されているエラー内容を確認してください。',
              type: 'error'
            });
            return false;
          }
        });
      });
    },
    onDownload() {
      let message = '現在の入力内容を保存して、Excelファイルを<br/>ダウンロードします。<br/>よろしいですか？';
      this.$confirm(message, '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'info',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.loading = true;
            let params = this.createParams(this.form.shuhoJokyoKubun, false);
            this.$axios.post('/gwr/shuho/shujiHokoku', params)
                .then(() => {
                  this.$axios.get('/gwr/shuho/downloadShuho/' + this.form.torokuBi + '/' + this.form.shainId, { responseType: 'blob' })
                    .then((response) => {
                      downloadFile(this, response);
                    })
                    .catch((error) => {
                      notifyError(this, error, 'ダウンロードエラー');
                    });
                })
                .catch((error) => {
                  notifyError(this, error, '保存エラー');
                });
      });
    },
    onDelete() {
      let message = '下書き保存されている週報を削除します。<br/>よろしいですか？';
      this.$confirm(message, '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'info',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.loading = true;
        this.$axios.delete('/gwr/shuho/shujiHokoku/' + this.form.torokuBi + '/' + this.form.shainId)
          .then((response) => {
            this.form.shainId = response.data.shainId;
            this.form.shainShimei = response.data.shainShimei;
            this.form.bushoMei = '';
            this.form.torihikisakiMei = '';
            this.form.genbaMei = '';
            this.form.kikan = '';
            this.form.taicho = 5;
            this.form.fuka = 5;
            this.form.genbaManzokudo = 5;
            this.form.thisWeekTask = '';
            this.form.nextWeekTask = '';
            this.form.problems = '';
            this.form.irregularWork = '';
            this.form.sonotaJokyo = '';
            this.form.shuhoJokyoKubun = '';
            this.loading = false;
          })
          .catch((error) => {
            notifyError(this, error, 'データ削除エラー');
          });
        });
    },
    createParams(shuhoJokyoKubun, sendMail) {
      let params = new URLSearchParams(this.form);
      params.set('shuhoJokyoKubun', shuhoJokyoKubun);
      params.set('bushoMei', this.form.bushoMei ?? '');
      params.set('torihikisakiMei', this.form.torihikisakiMei ?? '');
      params.set('genbaMei', this.form.genbaMei ?? '');
      params.set('kikan', this.form.kikan ?? '');
      params.set('zangyo', this.form.zangyo ?? '');
      params.set('taicho', this.form.taicho ?? 5);
      params.set('fuka', this.form.fuka ?? 5);
      params.set('genbaManzokudo', this.form.genbaManzokudo ?? 5);
      params.set('thisWeekTask', this.form.thisWeekTask ?? '');
      params.set('nextWeekTask', this.form.nextWeekTask ?? '');
      params.set('problems', this.form.problems ?? '');
      params.set('irregularWork', this.form.irregularWork ?? '');
      params.set('sonotaJokyo', this.form.sonotaJokyo ?? '');
      params.set('existNotRegistDayFlg', this.form.existNotRegistDayFlg ?? false);
      params.set('sendMail', sendMail);
      return params;
    },
  },
}
</script>

<style scoped>
#shujiCard {
  width: 1100px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: 20px;
}
#shainShimei {
  font-size: 15px;
  font-weight: bold;
  margin-right: 10px;
}
#shujiCard >>> .el-form-item {
  text-align: left;
}
#shujiCard >>> #torokuBi {
  font-family: inherit;
  width: 135px !important;
}
#shujiCard >>> .el-date-editor.el-input.el-input--medium.el-input--prefix.el-input--suffix.el-date-editor--date {
  width: 135px !important;
}
#shujiCard >>> #bushoMei {
  width: 380px !important;
}
#shujiCard >>> #torihikisakiMei {
  width: 535px !important;
}
#shujiCard >>> #genbaMei {
  width: 435px !important;
}
#shujiCard >>> #kikan {
  width: 535px !important;
}
#shujiCard >>> #kikanLabel {
  font-size: 15px;
  padding: 0 15px;
}
#shujiCard >>> #zangyo {
  width: 435px !important;
}
#shujiCard >>> #zangyoLabel {
  font-size: 15px;
  padding: 0 15px;
}
#shujiCard >>> .el-tag {
  width: 1060px;
}
.subtitleBar >>> .el-form-item__content {
  margin-left: 0px !important;
}
#shujiCard >>> .el-slider {
  width: 700px !important;
}
#shujiCard >>> .el-slider__marks-text {
  width: 30px !important;
}
#shujiCard >>> .el-textarea__inner {
  width: 945px !important;
}
#shujiCard >>> #irregularWork {
  padding-left: 30px;
}
#shujiCard >>> .bottom-items  {
  margin-bottom: 22px;
}
#minyuryokuAlert {
  color: red;
  font-weight: bold;
}
#copyButton {
  float: right;
}
.jochoComment-tooltip {
  white-space: pre;
  font-size: 14px;
}
</style>
